<template>
    <!-- Generico Fechas -->
    <select class="form-select select-tiempo form-select-sm" aria-label="Default select example"
        @change="handleGenericDateChange">
        <option selected>Siempre</option>
        <option value="1">Hoy</option>
        <option value="7">Últimas 24 horas</option>
        <option value="2">Este mes</option>
        <option value="3">Este año</option>
        <option value="4">Últimos 7 días</option>
        <option value="5">Últimos 15 días</option>
        <option value="6">Últimos 30 días</option>
    </select>
    <!-- FECHA DESDE -->
    <div class="filter-group">
        <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="showStartDate" v-model="showStartDate" />
            <label class="form-check-label" for="flexCheckDefault"> Desde </label>
        </div>
        <div v-if="showStartDate" class="active-filter">
            <input type="date" class="form-control" :value="startDate"
                @input="setStartDate(($event.target as HTMLInputElement)?.value)" />
        </div>
    </div>
    <!-- FECHA HASTA -->
    <div class="filter-group">
        <div class="form-check">
            <input class="form-check-input" type="checkbox" value="" id="showEndDate" v-model="showEndDate" />
            <label class="form-check-label" for="flexCheckDefault"> Hasta </label>
        </div>
        <div v-if="showEndDate" class="active-filter">
            <input type="date" class="form-control" :value="endDate"
                @input="setEndDate(($event.target as HTMLInputElement)?.value)" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'

const props = defineProps<{
    startDate: string
    endDate: string
}>()

const showEndDate = ref(false)
const showStartDate = ref(false)

// Para que sean reactivas y puedas usarlas como v-model en el padre:
const emit = defineEmits<{
    (e: 'update:startDate', value: string): void
    (e: 'update:endDate', value: string): void
}>()

// Cuando cambian internamente, emite el cambio al padre
watch(() => props.startDate, val => emit('update:startDate', val))
watch(() => props.endDate, val => emit('update:endDate', val))

// Si necesitas modificar los valores desde el componente, usa:
function setStartDate(val: string) {
    emit('update:startDate', val)
}
function setEndDate(val: string) {
    emit('update:endDate', val)
}

function handleGenericDateChange(event: Event) {
    const value = (event.target as HTMLSelectElement).value
    const today = new Date()
    let startDate = ''
    let endDate = today.toISOString().slice(0, 10) // formato YYYY-MM-DD
    setEndDate(endDate)

    switch (value) {
        case '1': // Hoy
            startDate = endDate
            break
        case '7': { // Últimas 24 horas
            const yesterday = new Date(today.getTime() - 24 * 60 * 60 * 1000)
            startDate = yesterday.toISOString().slice(0, 10)
            // Para últimas 24 horas, el endDate debería ser hoy
            endDate = today.toISOString().slice(0, 10)
            setEndDate(endDate)
            break
        }
        case '2': // Este mes
            startDate = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().slice(0, 10)
            break
        case '3': // Este año
            startDate = new Date(today.getFullYear(), 0, 1).toISOString().slice(0, 10)
            break
        case '4': // Últimos 7 días
            startDate = new Date(today.getTime() - 6 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10)
            break
        case '5': // Últimos 15 días
            startDate = new Date(today.getTime() - 14 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10)
            break
        case '6': // Últimos 30 días
            startDate = new Date(today.getTime() - 29 * 24 * 60 * 60 * 1000).toISOString().slice(0, 10)
            break
        default:
            // Siempre: limpiar fechas y ocultar
            setStartDate('')
            return
    }
    setStartDate(startDate)
}
</script>